import type { Problem } from './errors.ts';

export function toolErrorPayload(problem: Problem, toolName: string) {
  if (toolName !== 'patch_string_field') return problem;
  const { type: _type, title: _title, ...payload } = problem;
  return {
    ...payload,
    detail: payload.code === 'content_changed' ? 'Expected version check failed.' : payload.detail,
  };
}
